import { ApolloError } from '@apollo/client';
import {
  ApprovalStatus,
  GetLatestApprovalResponse,
} from '../../../__generated__/chirp/com/hubspot/product/approvals/rpc/ApprovalsRpc';
import { useGetLatestApprovalQuery } from '../../../__generated__/chirp/com/hubspot/product/approvals/rpc/ApprovalsRpc.hooks';
import {
  APP_GOVERNANCE_APPROVAL_ACTION,
  APP_GOVERNANCE_APPROVAL_TYPE_ID,
} from '../constants';

interface GetLatestProductApprovalRequestProps {
  approvableObjectId?: number;
}

interface GetLatestProductApprovalRequestResponse {
  data?: GetLatestApprovalResponse;
  requestStatus?: ApprovalStatus;
  requesterId?: string;
  hasLatestRequestData: boolean;
  loading: boolean;
  error?: ApolloError;
  refetch: Function;
}

//Retrieves latest approval request for a given objectId
export function useGetLatestProductApprovalRequest({
  approvableObjectId,
}: GetLatestProductApprovalRequestProps): GetLatestProductApprovalRequestResponse {
  const { data, loading, error, refetch } = useGetLatestApprovalQuery({
    variables: {
      approvalTypeId: APP_GOVERNANCE_APPROVAL_TYPE_ID,
      approvalAction: APP_GOVERNANCE_APPROVAL_ACTION,
      approvableObjectId:
        approvableObjectId === undefined ? 0 : approvableObjectId,
    },
    skip: approvableObjectId === undefined,
  });

  const requestStatus = data?.approval?.approvalStatus;
  const requesterId = data?.approval?.requester?.id;
  const hasLatestRequestData = data?.approval !== undefined;

  return {
    data,
    requestStatus,
    requesterId,
    hasLatestRequestData,
    loading,
    error,
    refetch,
  };
}
